import React from "react";
import { Checkbox } from "../ui/checkbox";
import ErrorText from "./error-text";
import { Label } from "../ui/label";

export default function FormikCheckbox({
  formikProps,
  onChange = () => {},
  name,
  style,
  className,
  color,
  label,
  text,
}) {
  return (
    <div>
      {label && (
        <Label className="mb-3" htmlFor="inputId">
          {label}
        </Label>
      )}
      <Checkbox
        checked={formikProps.values[name]}
        onCheckedChange={(e) => {
          formikProps.setFieldValue(name, !formikProps.values[name]);
          onChange(!formikProps.values[name]);
        }}
        style={style}
        className={className}
        color={color}
      >
        {" "}
        {text}
      </Checkbox>
      <ErrorText name={name} formikProps={formikProps} />
    </div>
  );
}
